import { NgModule } from '@angular/core';
import { ApplicationHistoryService } from './apis/application-history.service';
import { ApplicationMappingService } from './apis/application-mapping.service';
import { ApplicationService } from './apis/application.service';
import { ApplicationDataService } from './apis/applicationData.service';
import { DictionaryService } from './apis/dictionary.service';
import { DocumentsService } from './apis/documents.service';
import { FormsService } from './apis/forms.service';
import { LabelService } from './apis/labels.service';
import { LanguageService } from './apis/language.service';
import { LenderService } from './apis/lender.service';
import { LogsService } from './apis/logs.service';
import { MenuService } from './apis/menu.service';
import { JsonPartnerService } from './apis/mocks-api/json-partner.service';
import { PartnerService } from './apis/partner.service';
import { PosService } from './apis/pos.service';
import { RoleService } from './apis/role.service';
import { UsersService } from './apis/users.service';
import { LocksService } from './apis/locks.service';
import { NotificationService } from './apis/notification.service';

@NgModule({
  declarations: [
  ],
  imports: [
  ],
  exports: [
  ],
  providers: [
    RoleService,
    LabelService,
    MenuService,
    LogsService,
    DictionaryService,
    PartnerService,
    LanguageService,
    MenuService,
    UsersService,
    PosService,
    LenderService,
    RoleService,
    DictionaryService,
    ApplicationService,
    ApplicationMappingService,
    ApplicationHistoryService,
    FormsService,
    DocumentsService,
    JsonPartnerService,
    ApplicationDataService,
    LocksService,
    NotificationService,
  ],
})
export class ApisModule { }
